var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportIconGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Export@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Orders",
    transform: "translate(-1492.000000, -142.000000)",
    fill: "#acb5bd",
    fillRule: "nonzero",
    stroke: "#acb5bd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panel",
    transform: "translate(254.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-Copy",
    transform: "translate(1227.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Export",
    transform: "translate(12.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0000005,22.8300009 C12.3300005,22.8300009 12.6000005,22.5600009 12.6000005,22.2300009 L12.6000005,7.38000029 L17.1600007,11.7000005 C17.4000007,11.9400005 17.7900007,11.9100005 18.0000007,11.6700005 C18.2400007,11.4300005 18.2100007,11.0400004 17.9700007,10.8300004 L12.4200005,5.55000022 C12.1800005,5.34000021 11.8200002,5.34000021 11.5800005,5.55000022 L6.00000024,11.1000004 C5.76000023,11.3400005 5.76000023,11.7000005 6.00000024,11.9400005 C6.12000024,12.0600005 6.27000025,12.1200005 6.42000026,12.1200005 C6.57000026,12.1200005 6.72000027,12.0600005 6.84000027,11.9400005 L11.4000005,7.4400003 L11.4000005,22.2300009 C11.4000005,22.5600009 11.6700005,22.8300009 12.0000005,22.8300009 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600000024,9.06000036 C0.930000037,9.06000036 1.20000005,8.79000035 1.20000005,8.46000034 L1.20000005,2.10000008 C1.20000005,1.62000006 1.59000006,1.20000005 2.10000008,1.20000005 L21.9000009,1.20000005 C22.3800009,1.20000005 22.8000009,1.59000006 22.8000009,2.10000008 L22.8000009,8.49000034 C22.8000009,8.82000035 23.0700009,9.09000036 23.4000009,9.09000036 C23.7300009,9.09000036 24,8.82000035 24,8.49000034 L24,2.10000008 C24,0.960000038 23.0700009,0 21.9000009,0 L2.10000008,0 C0.960000038,0 0,0.930000037 0,2.10000008 L0,8.49000034 C0,8.82000035 0.270000011,9.06000036 0.600000024,9.06000036 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIconGray);
export default __webpack_public_path__ + "static/media/export_icon_gray.d714ab0503281d551abeb83e61a29ab6.svg";
export { ForwardRef as ReactComponent };